<template>
  <div class="rounded-lg overflow-hidden box-border w-full">
    <div class="scrollable-table-container" :style="tableStyle">
      <table
        class="w-full px-2 mt-5 relative table-ranking-podium"
        style="border-collapse: separate; border-spacing: 0"
      >
        <thead
          v-if="data.length > 0"
          :style="{
            position: isPresentationMode ? 'relative' : 'sticky',
            top: isPresentationMode ? '' : '0',
            zIndex: isPresentationMode ? 'auto' : '1',
            backgroundColor: isPresentationMode ? 'transparent' : '#f3f4f6',
            width: '100%',
          }"
          :class="{ 'shadow-custom': !isPresentationMode }"
        >
          <tr>
            <th
              v-for="header in headers"
              :key="header"
              class="p-4 text-xs sm:text-sm md:text-base text-center"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="bg-white py-6">
          <tr
            v-for="(row, rowIndex) in data"
            :key="rowIndex"
            class="rounded-lg"
          >
            <td class="label text-xs sm:text-sm md:text-base text-center">
              {{ row.top }}
            </td>
            <td class="label text-xs sm:text-sm md:text-base text-left">
              {{ row.nome }}
            </td>
            <td class="label text-xs sm:text-sm md:text-base text-center">
              {{ row.totalVendas }}
            </td>
            <td class="label text-xs sm:text-sm md:text-base text-center">
              {{ row.valorPrimeiraParcela }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PodiumPlacementTable',
  props: {
    headers: {
      type: Array,
      default: () => ['Top', 'Nome', 'Vendas Pagas', 'Valor 1⁠ª Parcela'],
    },
    data: {
      type: Array,
      default: () => [],
    },
    isPresentationMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableStyle() {
      const styles = {
        maxHeight: '100%',
        overflowY: 'auto',
      };

      if (this.isPresentationMode) {
        styles.maxHeight = 'none';
        styles.overflowY = 'hidden';
      }

      return styles;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

.bg-green-success {
  background-color: #e8faf0;
}
.shadow-custom {
  box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.05), 5px 0 5px 0 rgba(0, 0, 0, 0.05),
    0 -5px 5px 0 rgba(0, 0, 0, 0.05), 0 5px 5px 0 rgba(0, 0, 0, 0.05);
}
.red-error-10 {
  background-color: #faeaec;
}
.title {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #6d6d6d;
  letter-spacing: 0.15px;
  font-size: 0.75rem;
}
.label {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.25px;
  color: #434343;
}
.text-xxs {
  font-size: 0.625rem;
  line-height: 1rem;
}
.scrollable-tbody {
  padding-top: 50px;
}
.scrollable-table-container {
  display: block;
  max-height: 100%;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}
.scrollable-table-container::-webkit-scrollbar {
  width: 50px;
  height: 50px;
}
.scrollable-table-container::-webkit-scrollbar-track {
  background: transparent;
}
.scrollable-table-container::-webkit-scrollbar-thumb {
  background: #114880;
  border-radius: 8px;
  border: 23px solid transparent;
  background-clip: padding-box;
}
tbody tr:nth-child(even) {
  background-color: #fcf9f9;
}
.table-ranking-podium td,
.table-ranking-podium th {
  padding: 23px 20px;
}
</style>
